<template>
  <div>
    <el-card style="margin-top: 20px">
        <el-form ref="form" :model="playerModeForm" label-width="110px" class="demo-ruleForm" style="width: 900px;">
          <el-form-item label="应用名称：">{{sharebtnRowInfo ? sharebtnRowInfo.appliName : ''}}</el-form-item>
          <!--模式-->
          <el-form-item label="运行模式">
            <el-radio-group v-model="playerModeForm.playerMode" @change="changePlayerMode">
              <!--普通模式-->
              <el-radio label="0"> 普通模式</el-radio>
              <!--//演示模式-->
              <el-radio label="1" :disabled="sharebtnRowInfo.playMode == 0"> 演示模式</el-radio>
              <!-- 互动模式-->
              <el-radio label="2" :disabled="sharebtnRowInfo.playMode == 0">互动模式</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 公有应用  -->
          <template v-if="sharebtnRowInfo">
            <!-- 设置连接 -->
            <el-form-item label="设置连接" v-if="showExpireHours">
              <el-input-number  v-model="playerModeForm.expireHours" @change="handleChangeExpireHour" :min="1" :max="72" ></el-input-number>
              <!-- 小时有效 -->
              小时有效
            </el-form-item>
          <el-form-item label="URL：" v-if="playerModeForm.playerMode == '0' ">
            <el-input id="playerModeUrl1" v-model="playerModeForm.commUrl">
              <el-button slot="append" @click="copyPlayerModeUrl('playerModeUrl1')">复制</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="二维码：" v-show="playerModeForm.playerMode == '0'">
            <el-row type="flex" style="align-items: baseline;">
              <div id="qrcodePublic0" ref="qrcodePublic0"></div>
              &nbsp;
              <i class="el-icon-copy-document" @click="clickCopyImg('qrcodePublic0')" style="font-size: 18px;color:#000;cursor:pointer;"></i>
            </el-row>
          </el-form-item>
          <el-form-item label="演示者：" v-if="playerModeForm.playerMode == '1' || playerModeForm.playerMode == '2'">
            <el-input id="playerModeUrl2" v-model="playerModeForm.hostUrl">
              <el-button slot="append" @click="copyPlayerModeUrl('playerModeUrl2')">复制</el-button>
            </el-input>
          </el-form-item>
          <el-form-item label="观看者：" v-if="playerModeForm.playerMode == '1' || playerModeForm.playerMode == '2'">
            <el-input id="playerModeUrl3" v-model="playerModeForm.guestUrl">
              <el-button slot="append" @click="copyPlayerModeUrl('playerModeUrl3')">复制</el-button>
            </el-input>
          </el-form-item>
   <!--       <el-form-item label="演示者二维码 :" v-if="playerModeForm.playerMode == '1' || playerModeForm.playerMode == '2'">
            <el-row type="flex" style="align-items: baseline;">
              <div id="qrcodePublic1" ref="qrcodePublic1"></div>
              &nbsp;
              <i class="el-icon-copy-document" @click="clickCopyImg('qrcodePublic1')" style="font-size: 18px;color:#000;cursor:pointer;"></i>
            </el-row>
          </el-form-item>
          <el-form-item label="观看者二维码：" v-if="playerModeForm.playerMode == '1' || playerModeForm.playerMode == '2'">
            <el-row type="flex" style="align-items: baseline;">
              <div id="qrcodePublic2" ref="qrcodePublic2"></div>
              &nbsp;
              <i class="el-icon-copy-document" @click="clickCopyImg('qrcodePublic2')" style="font-size: 18px;color:#000;cursor:pointer;"></i>
            </el-row>
          </el-form-item>-->
          </template>
        </el-form>
    </el-card>
    <el-row type="flex" justify="center" style="marginTop: 30px">
      <el-button type="primary" @click="backFn">返回</el-button>
    </el-row>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
export default {
  data () {
    return {
      appUrl: this.$apiUrl+'/pocAppli/start?appliId=',
      playerModeForm: {
        appliId: "",
        playerMode: "0",
        commUrl: '',
        hostUrl: '',
        guestUrl: '',
        expireHours: 1
      },
      sharebtnRowInfo: {
      },
      showExpireHours: false,
      showAddPrivateAppliUrl: false,
      shareUrlTableData: [],
      privatePlayerModeForm: { // 当分享应用为私有应用时的表单字段
        playerModeDatetimerange: null,
        playerModeAuthcode: '',
      },
      playerModeUpdateDialogVisible: false, //分享链接编辑弹窗
      shareUrlUpdateForm: { // 分享链接编辑表单
        playerModeDatetimerange: null,
        authCode: '',
      }
    }
  },
  mounted: async function(){
    const appliInfo = this.$route.query;
    this.sharebtnRowInfo = {
      appliId: appliInfo.appliId,
      appliName: appliInfo.appliName,
      playMode: appliInfo.playMode,
    };
    this.playerModeForm.appliId = appliInfo.appliId;
      await this.setCommUrl().then(resp => {
        this.$nextTick(() => {
          console.log(this.playerModeForm.commUrl)
          this.getQrCode('qrcodePublic0', this.playerModeForm.commUrl);
        })
      });
  },
  methods: {
    backFn() {
      this.$router.push('/appli/index?page=' + this.$route.query.page);
    },
    changePlayerMode: async function (val) {
      var that = this;
      // 切换模式-直接拼接出来相应url
        //获取当前时间 + num 小时时间戳
        var timestamp = new Date().getTime() + (this.playerModeForm.expireHours) * 60 * 60 * 1000;
        if (val == 0) {
          this.setCommUrl();
          this.getQrCode('qrcodePublic0', this.playerModeForm.commUrl);
        } else {
          await that.createAuthCode().then(async res => {
            that.playerModeForm.hostUrl = that.appUrl + that.playerModeForm.appliId
              + '&playerMode=' + val + '&userType=1&authCode=' + res;
            that.playerModeForm.guestUrl = that.appUrl + that.playerModeForm.appliId
              + '&playerMode=' + val + '&userType=0&authCode=' + res;
            await that.createSignature(that.playerModeForm.appliId,timestamp).then(res1 => {
              if (res1 != undefined) {
                var tokenStr = "&wsId=" + res1.wsId
                  + "&timestamp=" + res1.timestamp + "&signature=" + res1.signature
                that.playerModeForm.hostUrl += tokenStr
                that.playerModeForm.guestUrl += tokenStr
              }
            })
          })
          this.getQrCode('qrcodePublic1', this.playerModeForm.hostUrl);
          this.getQrCode('qrcodePublic2', this.playerModeForm.guestUrl);
        }
    },
    createSignature: function (appliId,timestamp) {
      return new Promise((resolve, reject) => {
        var params = {}
        params.appliId = appliId
        params.timestamp = timestamp
        this.getRequest("/pocAppli/getShareUrlSignature", params, {
          timeout: 0,
        }).then((res) => {
          if (res.data.code === 1000) {
            //当没有设置客户端密钥的时候，res.data.result为undefined
            resolve(res.data.result);
          } else {
            resolve('');
          }
        }).catch((err) => {
          console.log('mergeRequest -> err', err);
          reject();
        });
      });
    },
    createAuthCode: function () {
      return new Promise((resolve, reject) => {
        this.getRequest("/pocAppli/getRoomCode", {}, {
          timeout: 0,
        }).then((res) => {
          // 清除storage
          if (res.data.code === 1000) {
            resolve(res.data.result.roomCode);
          } else {
            resolve('');
          }
        }).catch((err) => {
          console.log('mergeRequest -> err', err);
          reject();
        });
      });
    },
    handleChangeExpireHour:function(num){
      this.playerModeForm.expireHours = num;
      this.changePlayerMode(this.playerModeForm.playerMode)
    },
    copyPlayerModeUrl: function (id) {
      let text = document.getElementById(id);
      text.select();
      document.execCommand('Copy');
      this.$message({type: 500, message:"拷贝成功"});
    },
    setCommUrl: async function () {
      var that = this;
      this.playerModeForm.commUrl = this.appUrl + this.playerModeForm.appliId
      var timestamp = new Date().getTime() + (this.playerModeForm.expireHours) * 60 * 60 * 1000;
        //获取
      await that.createSignature(that.playerModeForm.appliId,timestamp).then(res1 => {
        //当没有设置客户端秘钥的时候，res1为undefined
        if (res1 != undefined) {
          //显示签名有效期时间
          that.showExpireHours = true;
          var tokenStr = "&wsId=" + res1.wsId
            + "&timestamp=" + res1.timestamp + "&signature=" + res1.signature
          that.playerModeForm.commUrl += tokenStr
        }else {
          that.showExpireHours = false;
        }
      })
    },
    // 复制二维码
    async clickCopyImg (i) {
      // http环境不支持复制图片，提示用户手动复制
      if (!(location.protocol === "https:") && !(location.hostname === "127.0.0.1") && !(location.hostname === "localhost")) {
        this.$message.warning("http环境不支持复制图片，请手动复制");
        return false;
      }
      // 将 qrcode 生成的二维码利用canvas自带的 toDataURL 转成base64 格式 然后再转成 Blob格式 使用 clipboard.write 复制
      const canvasImg = this.$refs[i];
      // document.getElementById(i); // 获取canvas类型的二维码
      let type = "image/png"; // 定义图片类型（canvas转的图片一般都是png，也可以指定其他类型）
      let conversions = this.base64ToBlob(canvasImg.querySelector('img').src, type);
      try {
        await navigator.clipboard.write([
          new ClipboardItem({
            [conversions.type]: conversions
          })
        ])
        this.$message.success("复制成功");
      } catch (error) {
        console.error(error)
      }
    },
    // 生成二维码
    getQrCode(refdom,url) {
      if(document.getElementById(refdom).innerHTML)document.getElementById(refdom).innerHTML = '';
      this.$nextTick(() => {
        new QRCode(this.$refs[refdom], {
          width: 120,
          height: 120,
          colonDark: '#000',
          colonLight: '#fff',
          text: url
        })
      })
    },
    //  将base64转成blob格式
    base64ToBlob(urlData, type) {
      let arr = urlData.split(',');
      let mime = arr[0].match(/:(.*?);/)[1] || type;
      // 去掉url的头，并转化为byte
      let bytes = window.atob(arr[1]);
      // 处理异常,将ascii码小于0的转换为大于0
      let ab = new ArrayBuffer(bytes.length);
      // 生成视图（直接针对内存）：8位无符号整数，长度1个字节
      let ia = new Uint8Array(ab);
      for (let i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      return new Blob([ab], {
        type: mime
      });
    },

  }
}
</script>
<style lang='scss' scoped></style>
